import { getToken } from "./api-util";
import triyoAPI from "./triyo";

const config = (method, header) => {
  let token = getToken();
  return {
    method: method,
    credentials: "include",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

export const GetAllSubDepartments = (data) => {
  return triyoAPI.post(`/subdepartment/GetAllSubDepartments`, data, config("POST", true));
};

export const GetAllSubDepartmentsForTelerikGrid = (data) => {
  return triyoAPI.post(`/subdepartment/GetAllSubDepartmentsForTelerikGrid`, data, config("POST", true));
};

export const GetSubDepartmentFilters = () => {
  return triyoAPI.get(`/subdepartment/GetSubDepartmentFilters`, config());
};

export const GetAllSubDepartmentsForCreateScreen = (data) => {
    let obj = {
      Filters: JSON.stringify(data),
    };
    return triyoAPI.post(
      `/subdepartment/GetAllSubDepartmentsForCreateScreen`,
      obj,
      config("POST")
    );
};

export const GetSubDepartment = (data) => {
  return triyoAPI.get(`subdepartment/GetSubDepartmentById?subDepartmentId=${data}`, config());
};

export const CreateSubDepartment = (data) => {
  return triyoAPI.post(`/Subdepartment/CreateSubDepartment`, data, config("POST"));
};

export const EditSubDepartment = (data) => {
  return triyoAPI.post(`/subdepartment/EditSubDepartment`, data, config("POST"));
};

export const ActiveSubDepartment = (data) => {
  return triyoAPI.post(`/subdepartment/ActiveSubDepartment`, data, config("POST"));
};

export const InactiveSubDepartment = (data) => {
  return triyoAPI.post(`/subdepartment/InactiveSubDepartment`, data, config("POST"));
};

export const DeleteSubDepartment = (data) => {
  return triyoAPI.post(`/subdepartment/RemoveSubDepartment`, data, config("POST"));
};

export const DeleteSubDepartments = (data) => {
  return triyoAPI.post(`/subdepartment/RemoveSubDepartments`, data, config("POST"));
};

export const DownloadSubDepartment = () => {
  return triyoAPI.get(`/subdepartment/DownloadSubDepartment`, config("GET"));
};

export const SubDepartmentExistsWithName = (data) => {
  return triyoAPI.get(
    `/subdepartment/GetSubDepartmentByName?subdepartmentName=${data}`,
    config("GET")
  );
};

export const GetDefaultLandingPage = () => {
  return triyoAPI.get(
    `/subdepartment/GetDefaultLandingPage`,
    config("GET")
  );
}

export const GetDefaultObjectLabels = () => {
  return triyoAPI.get(
    `/subdepartment/GetDefaultObjectLabels`,
    config("GET")
  );
};